import "./ShopPage.css";

import React from "react";

import { useState, useEffect, useRef } from "react";

import { Outlet, Link } from "react-router-dom";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

import { MiniCartCard } from "./MiniCartCard";

function valuetext(value) {
  return `${value}°C`;
}

export const ShopPage = ({
  handleCartItemsCountChange,
  itemsData,
  changeNavBar,
  handleAddToCart,
  cartContent,
  subtotalValue,
  handleRemoveItem,
  handleSetCurrentPage,
  currentPage,
}) => {
  const sideBarContainer = useRef(null);
  const shopContentContainer = useRef(null);
  const outletRef = useRef(null);

  const [isopenNike, setIsopenNike] = useState(false);
  const [isopenAdidas, setIsopenAdidas] = useState(false);
  const [isopenPuma, setIsopenPuma] = useState(false);
  const [isopenAvailableSizes, setIsopenAvailableSizes] = useState(false);

  const moveScreenToSideBar = () => {
    sideBarContainer.current.scrollIntoView();
  };

  const openCloseNike = () => {
    if (isopenNike === false) {
      setIsopenNike(true);
    } else {
      setIsopenNike(false);
    }
  };

  const openCloseAdidas = () => {
    if (isopenAdidas === false) {
      setIsopenAdidas(true);
    } else {
      setIsopenAdidas(false);
    }
  };

  const openClosePuma = () => {
    if (isopenPuma === false) {
      setIsopenPuma(true);
    } else {
      setIsopenPuma(false);
    }
  };

  const [refreshTrigger, setRefreshTrigger] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [priceRangeValue, setPriceRangeValue] = useState([0, 600]);
  const [sortingOption, setSortingOption] = useState("");

  const [availableSizesArr, setAvailableSizesArr] = useState([]);

  const [miniCartArr, setMiniCartArr] = useState([]);

  const [catalogueData, setCatalogueData] = useState(itemsData);
  const [chosenCategoryCatalogueData, setChosenCategoryCatalogueData] =
    useState(itemsData);
  const [filterCatalogueData, setFilterCatalogueData] = useState(itemsData);
  const [auxilaryCatalogueData, setAuxilaryCatalogueData] = useState(itemsData);
  const [isItemFocus, setIsItemFocus] = useState(false);

  const [itemFocusName, setItemFocusName] = useState("");

  const [chosenItemCategory, setChosenItemCategory] = useState("Всички");

  const handleFilterFocusItem = (category) => {
    let newCategoryArr = [];
    auxilaryCatalogueData.map((item) => {
      item.category.map((categoryInDB) => {
        if (categoryInDB === category) {
          newCategoryArr.push(item);
        }
      });
    });
    setCatalogueData(newCategoryArr);
    setFilterCatalogueData(newCategoryArr);
    setSortingOption("");
  };

  const handleFilterItemType = (itemType, brand) => {
    setCatalogueData([]);
    setTimeout(() => {
      setChosenItemCategory(`${brand} -> ${itemType}`);
      let newCategoryArr = [];
      auxilaryCatalogueData.map((item) => {
        if ((item.category[0] === itemType) & (item.category[1] === brand)) {
          newCategoryArr.push(item);
        }
      });
      handleSetCurrentPage(1);
      setCatalogueData(newCategoryArr);
      setChosenCategoryCatalogueData(newCategoryArr);
      setFilterCatalogueData(newCategoryArr);
      setSortingOption("");
    }, 500);

    if (window.innerWidth <= 1000) {
      outletRef.current.scrollIntoView();
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const handleFilterAge = (itemType, brand, age) => {
    setCatalogueData([]);
    setTimeout(() => {
      setChosenItemCategory(`${brand} -> ${itemType} -> ${age}`);
      let newCategoryArr = [];
      auxilaryCatalogueData.map((item) => {
        if (
          (item.category[0] === itemType) &
          (item.category[1] === brand) &
          (item.category[2] === age)
        ) {
          newCategoryArr.push(item);
        }
      });
      handleSetCurrentPage(1);
      setCatalogueData(newCategoryArr);
      setChosenCategoryCatalogueData(newCategoryArr);
      setFilterCatalogueData(newCategoryArr);
      setSortingOption("");
    }, 500);

    if (window.innerWidth <= 1000) {
      outletRef.current.scrollIntoView();
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const handleFilterAll = () => {
    setCatalogueData([]);
    setTimeout(() => {
      handleSetCurrentPage(1);
      setChosenItemCategory("Всички");
      setCatalogueData(auxilaryCatalogueData);
      setChosenCategoryCatalogueData(auxilaryCatalogueData);
      setFilterCatalogueData(auxilaryCatalogueData);
      setSortingOption("");
    }, 500);

    if (window.innerWidth <= 1000) {
      outletRef.current.scrollIntoView();
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const filterAvailableSize = (e) => {
    setCatalogueData([]);
    let itemsOfSize = [];

    setTimeout(() => {
      setChosenItemCategory(e.target.id);
      auxilaryCatalogueData.map((item) => {
        item.sizes.map((sizee) => {
          if (sizee.size === e.target.id && sizee.availableQuantity > 0) {
            itemsOfSize.push(item);
          }
        });
      });
      handleSetCurrentPage(1);
      setCatalogueData(itemsOfSize);
      setChosenCategoryCatalogueData(itemsOfSize);
      setFilterCatalogueData(itemsOfSize);
      setSortingOption("");
    }, 500);
    if (window.innerWidth <= 1000) {
      outletRef.current.scrollIntoView();
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };
  const handleFilterByPrice = () => {
    setCatalogueData([]);
    setTimeout(() => {
      let newPriceRangeArr = [];
      filterCatalogueData.map((item) => {
        if (
          (item.price >= priceRangeValue[0]) &
          (item.price <= priceRangeValue[1])
        ) {
          newPriceRangeArr.push(item);
        }
      });
      handleSetCurrentPage(1);
      setCatalogueData(newPriceRangeArr);
    }, 500);

    if (window.innerWidth <= 1000) {
      outletRef.current.scrollIntoView();
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const handleSearchFieldSubmit = (searchValue) => {
    setCatalogueData([]);
    setTimeout(() => {
      let modelsArr = [];
      let searchValueLowerCase = searchValue.toLowerCase();
      auxilaryCatalogueData.map((item) => {
        let itemNameLowerCase = item.name.toLowerCase();

        if (itemNameLowerCase.search(searchValueLowerCase) !== -1) {
          modelsArr.push(item);
        }
      });
      handleSetCurrentPage(1);
      setCatalogueData(modelsArr);
      setFilterCatalogueData(modelsArr);
    }, 500);
  };

  const handleChangeSelectMenu = (event) => {
    let searchValue = event.target.value;
    setCatalogueData([]);
    setTimeout(() => {
      let modelsArr = [];
      let searchValueLowerCase = searchValue.toLowerCase();
      chosenCategoryCatalogueData.map((item) => {
        let itemNameLowerCase = item.name.toLowerCase();
        if (itemNameLowerCase.search(searchValueLowerCase) !== -1) {
          modelsArr.push(item);
        }
      });
      handleSetCurrentPage(1);
      setCatalogueData(modelsArr);
      setFilterCatalogueData(modelsArr);
    }, 500);

    setSortingOption(event.target.value);
  };
  const handleChangeSlider = (event, newValue) => {
    setPriceRangeValue(newValue);
  };

  function handleIsItemFocus(newValue, newItemId) {
    setIsItemFocus(newValue);
    catalogueData.map((item) => {
      if (item.id === newItemId) {
        setItemFocusName(item.name);
      }
    });
  }

  const handleMoveToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    let href = window.location.href;
    let subHref = href.split("/")[3];

    if (subHref !== "/shop") {
      changeNavBar("isProducts", "rgba(41, 41, 41)", "white", "13rem", "row");
    }
    let availableSizes = [];

    auxilaryCatalogueData.map((item) => {
      if (
        item.category[0] === "Футболни-обувки" ||
        item.category[0] === "Стоножки" ||
        item.category[0] === "Маратонки"
      ) {
        item.sizes.map((sizee) => {
          if (sizee.availableQuantity > 0) {
            if (availableSizes.indexOf(sizee.size) === -1) {
              availableSizes.push(sizee.size);
            }
          }
        });
      }
    });
    setAvailableSizesArr(availableSizes.sort());
  }, []);

  useEffect(() => {
    setMiniCartArr(miniCartArr);
  }, [refreshTrigger]);

  return (
    <div className="shop-page-container">
      <div className="shop-title-section">
        <h1 className="shop-title">Каталог</h1>
      </div>
      <div ref={shopContentContainer} className="shop-content-container">
        <div ref={sideBarContainer} className="shop-side-bar">
          <div className="shop-side-bar-content">
            <p className="shop-side-bar-content-title">Количка</p>
            <div className="shop-side-bar-content-miniCart">
              {cartContent.length === 0 && (
                <p className="shop-side-bar-content-miniCart-no-products">
                  Количката е празна
                </p>
              )}
              {cartContent.map((item) => {
                return (
                  <MiniCartCard
                    id={item.id}
                    name={item.name}
                    price={item.price}
                    count={item.count}
                    imgSrc={item.imgSrc}
                    size={item.size}
                    handleRemoveFromCart={handleRemoveItem}
                  />
                );
              })}
            </div>
            <p className="shop-side-bar-content-total-price">
              Общо: {subtotalValue}лв.
            </p>
            {cartContent.length !== 0 && (
              <Link
                onClick={handleMoveToTop}
                to={"/cart"}
                className="shop-side-bar-content-to-cart"
              >
                Количка
              </Link>
            )}
            {cartContent.length !== 0 && (
              <Link
                onClick={handleMoveToTop}
                to={"/checkout"}
                style={{
                  opacity: isLoading === true ? "50%" : "100%",
                  pointerEvents: isLoading === true ? "none" : "all",
                }}
                className="shop-side-bar-content-checkout"
              >
                ПОРЪЧКА
              </Link>
            )}

            {isItemFocus === false ? (
              <div>
                <p className="shop-side-bar-content-Categories">Филтри</p>
                <ul
                  style={{
                    maxHeight: isopenNike === true ? "20.5rem" : "1.1rem",
                  }}
                  className="shop-side-bar-content-Categories-Coffee"
                >
                  <p
                    className="shop-side-bar-content-Categories-Coffee-p"
                    onClick={openCloseNike}
                  >
                    {" "}
                    <ArrowForwardIosIcon
                      sx={{
                        transition: "all 0.4s",
                        transform:
                          isopenNike === true
                            ? "rotate(90deg)"
                            : "rotate(0deg)",
                        fontSize: "11px",
                        mr: "5px",
                        color: "rgb(2, 85, 31)",
                      }}
                    />
                    Nike
                  </p>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Футболни-обувки", "Nike");
                      }}
                    >
                      Футболни обувки
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Футболни-обувки", "Nike", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Футболни-обувки", "Nike", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Стоножки", "Nike");
                      }}
                    >
                      Стоножки
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Стоножки", "Nike", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Стоножки", "Nike", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Маратонки", "Nike");
                      }}
                    >
                      Маратонки
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Маратонки", "Nike", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Маратонки", "Nike", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Дрехи", "Nike");
                      }}
                    >
                      Дрехи
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge(
                          "Дрехи",
                          "Nike",

                          "Възрастни"
                        );
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Дрехи", "Nike", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                </ul>
                <ul
                  style={{
                    maxHeight: isopenAdidas === true ? "20.5rem" : "1.1rem",
                  }}
                  className="shop-side-bar-content-Categories-greenCoffee"
                >
                  <p
                    className="shop-side-bar-content-Categories-Coffee-p"
                    onClick={openCloseAdidas}
                  >
                    {" "}
                    <ArrowForwardIosIcon
                      sx={{
                        transition: "all 0.4s",
                        transform:
                          isopenAdidas === true
                            ? "rotate(90deg)"
                            : "rotate(0deg)",
                        fontSize: "11px",
                        mr: "5px",
                        color: "rgb(2, 85, 31)",
                      }}
                    />
                    Adidas
                  </p>

                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Футболни-обувки", "Adidas");
                      }}
                    >
                      Футболни обувки
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge(
                          "Футболни-обувки",
                          "Adidas",
                          "Възрастни"
                        );
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Футболни-обувки", "Adidas", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Стоножки", "Adidas");
                      }}
                    >
                      Стоножки
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Стоножки", "Adidas", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Стоножки", "Adidas", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Маратонки", "Adidas");
                      }}
                    >
                      Маратонки
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Маратонки", "Adidas", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Маратонки", "Adidas", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Дрехи", "Adidas");
                      }}
                    >
                      Дрехи
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Дрехи", "Adidas", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Дрехи", "Adidas", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                </ul>
                <ul
                  style={{
                    maxHeight: isopenPuma === true ? "20.5rem" : "1.1rem",
                  }}
                  className="shop-side-bar-content-Italian"
                >
                  <p
                    className="shop-side-bar-content-Categories-Coffee-p"
                    onClick={openClosePuma}
                  >
                    {" "}
                    <ArrowForwardIosIcon
                      sx={{
                        transition: "all 0.4s",
                        transform:
                          isopenPuma === true
                            ? "rotate(90deg)"
                            : "rotate(0deg)",
                        fontSize: "11px",
                        mr: "5px",
                        color: "rgb(2, 85, 31)",
                      }}
                    />
                    Puma
                  </p>

                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Футболни-обувки", "Puma");
                      }}
                    >
                      Футболни обувки
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Футболни-обувки", "Puma", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Футболни-обувки", "Puma", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Стоножки", "Puma");
                      }}
                    >
                      Стоножки
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Стоножки", "Puma", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Стоножки", "Puma", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Маратонки", "Puma");
                      }}
                    >
                      Маратонки
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Маратонки", "Puma", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Маратонки", "Puma", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                  <ul className="shop-side-bar-content-Categories-ul-inner">
                    <p
                      className="shop-side-bar-content-Categories-ul-inner-p"
                      onClick={() => {
                        handleFilterItemType("Дрехи", "Puma");
                      }}
                    >
                      Дрехи
                    </p>

                    <li
                      onClick={() => {
                        handleFilterAge("Дрехи", "Puma", "Възрастни");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Възрастни
                    </li>
                    <li
                      onClick={() => {
                        handleFilterAge("Дрехи", "Puma", "Деца");
                      }}
                      className="shop-side-bar-content-Categories-ul-inne-li"
                    >
                      Деца
                    </li>
                  </ul>
                </ul>

                <p
                  onClick={handleFilterAll}
                  className="shop-side-bar-content-Uncategorized"
                >
                  <ArrowForwardIosIcon
                    sx={{
                      fontSize: "11px",
                      mr: "5px",
                      color: "rgb(2, 85, 31)",
                    }}
                  />
                  Всички
                </p>
                <div
                  className="shop-side-bar-content-available-sizes-container"
                  style={{
                    maxHeight:
                      isopenAvailableSizes === true ? "20.5rem" : "1.4rem",
                  }}
                >
                  <p
                    onClick={() => {
                      if (isopenAvailableSizes === false) {
                        setIsopenAvailableSizes(true);
                      } else {
                        setIsopenAvailableSizes(false);
                      }
                    }}
                    className="shop-side-bar-content-available-sizes-p"
                  >
                    <ArrowForwardIosIcon
                      sx={{
                        transition: "all 0.4s",
                        transform:
                          isopenAdidas === true
                            ? "rotate(90deg)"
                            : "rotate(0deg)",
                        fontSize: "11px",
                        mr: "5px",
                        color: "rgb(2, 85, 31)",
                      }}
                    />
                    Налични размери
                  </p>

                  <ul className="shop-side-bar-content-available-sizes-ul">
                    {availableSizesArr.map((item) => {
                      return (
                        <li
                          className="shop-side-bar-content-available-sizes-li"
                          onClick={filterAvailableSize}
                          id={item}
                        >
                          {item}
                        </li>
                      );
                    })}
                  </ul>
                </div>

                <p
                  ref={outletRef}
                  className="shop-side-bar-content-filter-title"
                >
                  Филтър за цена
                </p>
                <Box sx={{ width: "100%" }}>
                  <Slider
                    sx={{ color: "rgb(2, 85, 31)", height: "10px" }}
                    max={600}
                    getAriaLabel={() => "Temperature range"}
                    value={priceRangeValue}
                    onChange={handleChangeSlider}
                    valueLabelDisplay="auto"
                    getAriaValueText={valuetext}
                  />
                </Box>
                <p className="shop-side-bar-content-filter-priceRange-p">
                  Цена: {priceRangeValue[0]}лв.-{priceRangeValue[1]}лв.
                </p>
                <button
                  onClick={handleFilterByPrice}
                  className="shop-side-bar-content-filter-button"
                >
                  Провери
                </button>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
        <Outlet
          context={[
            catalogueData,
            sortingOption,
            handleChangeSelectMenu,
            handleAddToCart,
            miniCartArr,
            handleCartItemsCountChange,
            handleIsItemFocus,
            handleFilterFocusItem,
            moveScreenToSideBar,
            chosenItemCategory,
            handleSearchFieldSubmit,
            handleSetCurrentPage,
            currentPage,
          ]}
        />
      </div>
    </div>
  );
};
